import React from 'react';
require('../../scss/style.scss');
import Login from '../containers/login';
import { BrowserRouter } from 'react-router-dom';
import {constants, KeolisSpinner, moment} from '../containers/common/commonExport';

const LoginPage = (props) => (    

    <div className="col-md-6 loginContainer">            
                <div className="panel panel-info">
                    <div className="panel-heading loginTitle">
                        <div className="panel-title loginTitle">Hours of Service</div>
                        <img className="loginKeolisLogo" src={props.logo} />
                    </div>
                <div className="panel-body">
                    <h4 className="signInTitle text-center">Sign In</h4>
                <form name="form" onSubmit={props.handleSubmit}>
                    <div className={props.loginProgress ? 'loginSpinner' : 'hidden'}>
                        <KeolisSpinner />
                    </div>
                        
                    {props.showImpersonateUser &&
                    <div className={'form-group input-group' + (props.submitted && !props.username ? ' has-error' : '')}>
                                            <span className="input-group-addon"><i className="fa fa-lock" aria-hidden="true"></i></span>
                                            <input disabled={props.loginProgress ? true : false}  type="text" placeholder="Impersonate User Id" className="form-control" name="impersonateUserId" value={props.impersonateUserId} onChange={props.handleChange} />
                                        </div>
                    }

                    <div className="form-group text-center">
                        <button disabled={props.loginProgress ? true : false} className="btn btn-primary btn-block btn-full btnPrimaryColor" >LOGIN</button>
                    </div>
                    <span className={props.loginErrMsg && !props.loginProgress ? "loginErrMsg":"hidden"}>{props.loginErrMsg}</span>
                </form>
                </div>
            </div>
            </div>
         
);

export default LoginPage;
